/*****************************************
 * UI constants
 *****************************************/

export const uiData = {
  // select example text
  selectExample: ['סימולצית הדבקה'],

  // slider for Ki
  sliderTitle: 'מהירות',
  sliderMin: 1,
  sliderMax: 4,
  sliderStep: 1,

  // clickable buttons with value
  buttons: [
    {
      text: 'צעד אחד',
      value: 'step',
    },
  ],

  // input with value
  inputBoxes: [
    {
      value: 20,
      step: 1,
      min: 2,
      max: 80,
      label: 'מספר כדורים',
    },
    {
      value: 0.3,
      step: 0.1,
      min: 0.1,
      max: 1,
      label: ' סיכוי הדבקות ',
    },
  ],

  // colors: ['#00426F', '#65C3A4', '#5765AE', '#59926E', '#453f78', '#30A3B0'],
};

/*****************************************
 * Examples constants and global variables
 *****************************************/

const data = {
  examples: [
    {
      headerText: `סימולצית הדבקה`,
      subHeaderText: [''],
      interval: 5, // run speed
    },
  ],

  /*****************************************
   * Global variables
   *****************************************/

  exampleIdx: 0,
  lastExampleIdx: -1,

  // canvas viewBox
  // size: {
  //   width: 500,
  //   height: 300,
  // },

  state: 'new',

  // canvas settings
  canvasTitle: 'מונטה קרלו',

  // configure the simulation
  wallY: 0,
  wallWidth: 10,
  wallOpenTime: 5, // seconds
  wallYFinal: 50,
  maxSpeed: 3, // initial maxSpeed
  numOfBalls: 20, // initial
  sickProbability: 0.3,
};

export default data;
